import {Card} from '@primer/react-brand'
import {renderWithNoMarks} from '../../utils'
import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'
import type {ImageLinkItem} from '../../types'
import {SupportGrid} from './SupportGrid'

export function SupportImageCards({items}: {items: ImageLinkItem[]}) {
  return items.map((item, index) => (
    <SupportGrid.Item key={item.sys.id} index={index} total={items.length}>
      <Card href={item.fields.href} variant="minimal" fullWidth ctaText={item.fields.label}>
        <Card.Image
          src={`${item.fields.image.fields.file.url}?fm=webp`}
          alt={item.fields.image.fields.description ?? ''}
          sources={getImageSources(item.fields.image.fields.file.url, {
            maxWidth: MAX_CONTENT_WIDTH / 3,
          })}
        />
        <Card.Heading>{renderWithNoMarks(item.fields.heading)}</Card.Heading>
        <Card.Description>{renderWithNoMarks(item.fields.description)}</Card.Description>
      </Card>
    </SupportGrid.Item>
  ))
}
